document.addEventListener('DOMContentLoaded', () => {
    const secID = document.querySelector('script[data-header-transparent-shift]')?.getAttribute('data-header-transparent-shift');
    
    const sec = document.getElementById(secID);
    const headers = document.querySelectorAll('.shopify-section-group-header-group');
    

    if(!sec || !headers) return;

    function shiftSec() {
        // console.log('resize');
        let headerHeights = 0;
        headers.forEach(h => {
            headerHeights+=h.getBoundingClientRect().height;
        });
        
        sec.style.marginTop = `-${headerHeights}px`
   
    } 

    shiftSec();

    window.addEventListener('resize', shiftSec);
});